var _defs, _g, _path, _path2, _g2, _g3, _g4, _g5, _path3, _g6, _rect, _rect2, _path4, _path5, _g7, _g8, _rect3, _rect4, _rect5, _g9, _g10, _circle, _rect6, _rect7, _g11, _g12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgOnboarding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 434.947 608",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_lUPEp3MkcFZR5hft9JHmH7pN8wG3nlHD"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 434.947,
    height: 608
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.677,
    y: 0,
    width: 381.27,
    height: 494.601,
    transform: "matrix(-1,0,0,-1,488.625,494.601)",
    fill: "rgb(222,232,245)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M 173.529 74.639 C 173.529 98.031 154.566 116.994 131.174 116.994 C 107.782 116.994 88.819 98.031 88.819 74.639 C 88.819 51.247 107.782 32.284 131.174 32.284 C 142.417 32.25 153.21 36.701 161.161 44.652 C 169.111 52.602 173.563 63.395 173.529 74.639 L 173.529 74.639 Z ",
    fill: "rgb(193,216,237)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 131.17397795787076,
    cy: 62.23500000000013,
    r: 16.768,
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 161.696 104.008 C 153.71 112.305 142.69 116.994 131.174 116.994 C 119.658 116.994 108.638 112.305 100.653 104.008 C 106.364 91.245 117.893 82.522 131.174 82.522 C 144.455 82.522 155.985 91.245 161.696 104.008 Z ",
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 190.788,
    y: 32.547,
    width: 85.51,
    height: 25.841,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.788,
    y: 74.372,
    width: 209.017,
    height: 9.402,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.788,
    y: 99.758,
    width: 209.017,
    height: 9.402,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88.82,
    y: 143.531,
    width: 72.09,
    height: 11.104,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.82,
    y: 166.983,
    width: 310.986,
    height: 28.876,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.82,
    y: 217.115,
    width: 72.09,
    height: 11.104,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.82,
    y: 240.567,
    width: 310.986,
    height: 60.433,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.82,
    y: 314.151,
    width: 310.986,
    height: 28.876,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.82,
    y: 357,
    width: 310.986,
    height: 59.611,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 209.486,
    y: 441.07,
    width: 69.652,
    height: 21.13,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(193,216,237)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "move"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 250.603 40.583 L 378.083 40.583 C 387.839 40.583 395.759 48.504 395.759 58.259 L 395.759 318.374 C 395.759 328.129 387.839 336.049 378.083 336.049 L 250.603 336.049 C 240.847 336.049 232.927 328.129 232.927 318.374 L 232.927 58.259 C 232.927 48.504 240.847 40.583 250.603 40.583 Z",
    style: {
      stroke: "none",
      fill: "rgba(255, 255, 255, 0.6)",
      strokeMiterlimit: 10
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 378.083 340.633 L 250.604 340.633 C 238.316 340.619 228.358 330.661 228.344 318.374 L 228.344 58.26 C 228.358 45.972 238.316 36.014 250.604 36 L 378.084 36 C 390.372 36.014 400.329 45.972 400.344 58.26 L 400.344 318.374 C 400.329 330.662 390.371 340.62 378.083 340.633 L 378.083 340.633 Z  M 250.604 45.167 C 243.377 45.176 237.522 51.032 237.513 58.258 L 237.513 318.374 C 237.521 325.6 243.377 331.456 250.604 331.464 L 378.084 331.464 C 385.31 331.456 391.166 325.6 391.175 318.374 L 391.175 58.26 C 391.166 51.034 385.31 45.178 378.084 45.169 L 250.604 45.167 Z ",
    fill: "rgb(193,216,237)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: " M 286.431 40.583 L 342.255 40.583 L 342.255 51.415 C 342.255 55.892 338.626 59.522 334.148 59.522 L 294.538 59.522 C 290.06 59.522 286.43 55.892 286.43 51.415 L 286.43 40.583 L 286.431 40.583 Z ",
    fill: "rgb(193,216,237)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 259.515,
    y: 234.628,
    width: 50.29,
    height: 21.532,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#023ca2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.881,
    y: 234.628,
    width: 50.29,
    height: 21.532,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(193,216,237)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M 350.629 137.039 C 350.643 146.422 347.006 155.442 340.489 162.192 C 335.596 151.257 325.72 143.792 314.349 143.792 C 302.967 143.792 293.092 151.268 288.198 162.203 C 276.867 150.431 274.8 132.539 283.149 118.494 C 291.498 104.45 308.203 97.716 323.958 102.046 C 339.712 106.376 350.631 120.7 350.629 137.039 L 350.629 137.039 Z ",
    fill: "rgb(193,216,237)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 314.34272157188514,
    cy: 126.41090909090906,
    r: 14.36623376623379,
    fill: "rgb(243,245,253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 340.489 162.192 C 333.65 169.303 324.211 173.323 314.345 173.325 C 304.48 173.327 295.039 169.311 288.198 162.203 C 293.091 151.268 302.967 143.792 314.348 143.792 C 325.72 143.792 335.595 151.257 340.489 162.192 Z ",
    fill: "rgb(243,245,253)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 259.515,
    y: 187.686,
    width: 109.657,
    height: 4.379,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(222,232,245)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.515,
    y: 199.607,
    width: 109.657,
    height: 4.379,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(222,232,245)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.515,
    y: 211.936,
    width: 50.29,
    height: 4.379,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(222,232,245)"
  })))), /*#__PURE__*/React.createElement("g", null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M 93.376 393.923 C 95.809 393.123 98.305 394.023 100.694 395.837 C 97.548 387.893 96.249 380.717 101.628 380.394 C 105.392 380.168 108.275 383.056 110.465 387.16 C 111.235 379.943 113.222 374.56 117.674 376.344 C 122.561 378.304 123.305 385.019 122.564 392.044 C 124.719 388.456 127.035 386.455 129.14 388.558 C 135.422 394.84 120.002 412.545 120.002 412.545 L 116.173 412.545 L 113.987 414.917 C 114.43 415.852 114.672 416.41 114.672 416.41 L 111.896 422.058 C 111.896 422.058 83.278 397.228 93.376 393.923 Z ",
    fill: "rgb(141,219,224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 100.24 434.71 L 121.913 434.71 L 125.541 409.409 L 96.612 409.409 L 100.24 434.71 L 100.24 434.71 Z ",
    fill: "rgb(193,216,237)"
  }))), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: " M 21.74 580.51 L 160.999 580.51 L 160.999 433.828 L 21.74 433.828 L 21.74 580.51 Z  M 28.269 573.98",
    fill: "rgba(255,255,255,0.6)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 141.602,
    y: 580.51,
    width: 11.553,
    height: 12.735,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(193,216,237)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.686,
    y: 580.51,
    width: 11.553,
    height: 12.735,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(193,216,237)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.74,
    y: 435.304,
    width: 48.473,
    height: 146.682,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(193,216,237)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 153.303,
    y: 438.553,
    width: 49.639,
    height: 141.957,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(193,216,237)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: " M 66.948 581.986 L 206.207 581.986 L 206.207 435.304 L 66.948 435.304 L 66.948 581.986 Z  M 199.677 575.456 L 73.477 575.456 L 73.477 441.834 L 199.677 441.834 L 199.677 575.456 Z ",
    fill: "rgb(222,232,245)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: " M 66.948 581.986 L 206.207 581.986 L 206.207 501.115 L 66.948 501.115 L 66.948 581.986 Z  M 199.677 575.456 L 73.477 575.456 L 73.477 507.645 L 199.677 507.645 L 199.677 575.456 Z ",
    fill: "rgb(222,232,245)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M 143.077 453.469 L 143.077 462.81 L 143.077 501.062 L 83.92 501.062 L 83.92 462.81 L 83.92 453.469 L 143.077 453.469 L 143.077 453.469 Z ",
    fill: "rgb(193,216,237)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.31,
    y: 462.81,
    width: 59.157,
    height: 38.252,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(222,232,245)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.31,
    y: 462.81,
    width: 59.157,
    height: 2.867,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(193,216,237)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.309,
    y: 453.469,
    width: 59.157,
    height: 9.341,
    transform: "matrix(-1,0,0,-1,265.776,916.279)",
    fill: "rgb(222,232,245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 139.444 470.492 L 126.332 470.492 C 125.58 470.492 124.969 471.103 124.969 471.855 L 124.969 474.873 C 124.969 475.625 125.58 476.236 126.332 476.236 L 139.444 476.236 C 140.196 476.236 140.807 475.625 140.807 474.873 L 140.807 471.855 C 140.807 471.103 140.196 470.492 139.444 470.492 Z ",
    fill: "rgb(255,255,255)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 185.759,
    y: 580.51,
    width: 11.553,
    height: 12.735,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(222,232,245)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.843,
    y: 580.51,
    width: 11.553,
    height: 12.735,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(222,232,245)"
  }))), /*#__PURE__*/React.createElement("g", null, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88.985,
    y: 560.893,
    width: 64.314,
    height: 14.563,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(193,216,237)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 87.88,
    y: 531.8,
    width: 64.314,
    height: 14.563,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(193,216,237)"
  })), /*#__PURE__*/React.createElement("g", null, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 110.932,
    y: 560.893,
    width: 68.012,
    height: 14.563,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(222,232,245)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.62
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.62
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.483,
    y: 560.893,
    width: 3.301,
    height: 14.563,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(193,216,237)"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.62
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.62
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.086,
    y: 560.893,
    width: 3.301,
    height: 14.563,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(193,216,237)"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 171.14626053292443,
    cy: 568.1751370186599,
    r: 4.695999999999998,
    fill: "rgb(243,245,253)"
  }))), /*#__PURE__*/React.createElement("g", null, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 109.827,
    y: 531.8,
    width: 68.012,
    height: 14.563,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(222,232,245)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 125.998,
    y: 535.08,
    width: 47.461,
    height: 8.003,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(243,245,253)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.62
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.62
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.378,
    y: 531.8,
    width: 6.247,
    height: 14.563,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(193,216,237)"
  })))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 83.739,
    y: 546.346,
    width: 64.314,
    height: 14.563,
    transform: "matrix(-1,0,0,-1,231.793,1107.255)",
    fill: "rgb(193,216,237)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 105.686,
    y: 546.346,
    width: 68.012,
    height: 14.563,
    transform: "matrix(-1,0,0,-1,279.385,1107.255)",
    fill: "rgb(243,245,253)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.846,
    y: 546.346,
    width: 3.301,
    height: 14.563,
    transform: "matrix(-1,0,0,-1,332.994,1107.255)",
    fill: "rgb(222,232,245)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.243,
    y: 546.346,
    width: 3.301,
    height: 14.563,
    transform: "matrix(-1,0,0,-1,319.788,1107.255)",
    fill: "rgb(222,232,245)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 113.48326053292479,
    cy: 553.6281370186601,
    r: 4.695999999999998,
    fill: "rgb(222,232,245)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 123.132,
    y: 550.058,
    width: 30.023,
    height: 7.139,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(222,232,245)"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgOnboarding);
export default __webpack_public_path__ + "static/media/SvgOnboarding.215e44e78d5ef40fdabe940924c55bc7.svg";
export { ForwardRef as ReactComponent };